import React from 'react';
import { Chip } from '@app/core';
import { ParticipationStatus, useSession } from '@app/api';
import { getColorForParticipationStatus } from 'lib/participationUtils';
import { useTranslation } from 'react-i18next';

interface Props {
  status: ParticipationStatus;
  className?: string;
  sessionId?: string;
}

export const ParticipationStatusLabel = ({
  status,
  className,
  sessionId,
}: Props) => {
  const { data: session } = useSession(sessionId);
  const { t } = useTranslation();

  return (
    <Chip
      color={getColorForParticipationStatus(status)}
      overGray
      className={className}
    >
      {t(`sessions.details.monitoring.status.${status}`, {
        context: session?.studyType?.toLowerCase(),
      })}
    </Chip>
  );
};
